import Handlebars from 'handlebars';

const clonedEscapeExpression = Handlebars.Utils.escapeExpression;

Handlebars.Utils.escapeExpression = function (string) {
  return clonedEscapeExpression(string).replace(/&#x3D;/g, '=');
};

export default Handlebars;



// WEBPACK FOOTER //
// ./node_modules/@okta/courage/src/util/handlebars/handle-url.js